export default __webpack_public_path__ + "static/media/excel.bf3d7d82.svg";